module.exports = __webpack_public_path__ + "ipetbooking-landing/img/interface12@1.391e2c39.png";